import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navpages from "./components/Navpages";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFontLoading } from "./hooks/useFontLoading";

function App() {
  const { i18n } = useTranslation();
  const { fontsLoaded } = useFontLoading();

  const lang = navigator.language;

  useEffect(() => {
    lang && i18n.changeLanguage(lang.split("-")[0]);
    // Dynamically load non-critical CSS
    const slick = document.createElement('link');
    slick.rel = 'stylesheet';
    slick.href = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css';
    document.head.appendChild(slick);

    const slickTheme = document.createElement('link');
    slickTheme.rel = 'stylesheet';
    slickTheme.href = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css';
    document.head.appendChild(slickTheme);

    const aos = document.createElement('link');
    aos.rel = 'stylesheet';
    aos.href = 'https://unpkg.com/aos@2.3.4/dist/aos.css';
    document.head.appendChild(aos);
  }, [lang]);

  return (
    <>
      <Navpages />
    </>
  );
}

export default App;
